<template>
  <div v-if="isShow" class="session-mask flex flex-item-center flex-center">
    <div v-if="sessionStatus === 0">
      会话已结束，
      <span class="link" @click="sessionOpenClick">点击此处</span>
      开启会话
    </div>
    <div v-if="sessionStatus == 1 && guideJson?.msgStatus == 1 && !sessionError">
      <div v-html="guideJson?.workingText" @click="leaveMsgClick"></div>
    </div>
    <div v-if="sessionStatus == 3 && guideJson.msgStatus == 1 && !sessionError">
      <div v-html="guideJson?.unWorkingText" @click="leaveMsgClick"></div>
    </div>
    <div v-if="guideJson?.msgStatus == 0 && !sessionError">
      <div v-html="guideJson?.closeText"></div>
    </div>
    <div class="flex flex-item-center" v-if="sessionError && sessionStatus !== 0">
      当前会话异常
      <div class="flex flex-item-center">
        <div class="session-mask__error-dot1 dot"></div>
        <div class="session-mask__error-dot2 dot"></div>
        <div class="session-mask__error-dot3 dot"></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, watch, ref, computed, defineEmits, getCurrentInstance } from 'vue'
import { ElMessage } from 'element-plus'
import { isJSON } from '@/utils/index'
const { proxy } = getCurrentInstance()
const props = defineProps({
  showType: { type: Number, default: 1 },
  sessionStatus: { type: Number },
  sessionError: { type: Boolean },
  orgId: { type: String },
  invite: { type: Boolean } //会话邀请
})
const emit = defineEmits(['start', 'leave'])
const isShow = computed(() => {
  if (props.invite) return false
  return (props.showType === 2 && props.sessionStatus !== 2) || props.sessionError
})
const guideJson = ref({})
// 获取在线客服留言开关
const getLeaveMsgConfig = async () => {
  let res = await proxy.$http.post('/sys/config/getExternalVal', { key: 'leave.word', orgId: props.orgId })
  if (res.code === 0) {
    let data = isJSON(res.data) ? JSON.parse(res.data) : {}
    guideJson.value = data?.guideJson || {}
  } else {
    ElMessage.error(res.msg)
  }
}
// 重启会话
const sessionOpenClick = () => {
  emit('start')
}
// 开启留言
const leaveMsgClick = () => {
  emit('leave')
}
watch(
  () => props.orgId,
  (newVal) => {
    if (newVal) {
      getLeaveMsgConfig()
    }
  },
  { immediate: true }
)
</script>
<style lang="less" scoped>
.session-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
  color: #333;
  font-size: 12px;
  padding: 0 15px;
  .link {
    color: #3571f0;
    cursor: pointer;
  }
  .dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    margin: 10px;
    background-color: #5289ff;
  }
  &__error-dot1 {
    animation: jump 1.6s -0.32s linear infinite;
  }
  &__error-dot2 {
    animation: jump 1.6s -0.16s linear infinite;
  }
  &__error-dot3 {
    animation: jump 1.6s linear infinite;
  }
  @keyframes jump {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(2);
      transform: scale(2);
    }
  }
}
</style>
